export default function PortalExpired() {
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50">
      <div className="text-center max-w-sm px-6">
        <div className="font-heading text-2xl font-bold text-slate-900" data-testid="portal-expired">You're signed out</div>
        <p className="mt-2 text-sm text-slate-600">Ask your agent to send you a fresh sign-in link.</p>
      </div>
    </div>
  );
}
